import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PartnerConsltantsDashboardComponent } from './partner-consltants-dashboard/partner-consltants-dashboard.component';
import { PartnerConsListComponent } from './take-action/partner-cons-list/partner-cons-list.component';
import { AppComponent } from './app.component';
import { PartnerConsCompleteddocsComponent } from './partner-cons-completeddocs/partner-cons-completeddocs.component';
import { ViewVendorConInformationDocsComponent } from './view-vendor-con-information-docs/view-vendor-con-information-docs.component';


const routes: Routes = [
  {
    path:'',
    component:PartnerConsListComponent,pathMatch: "full"
    //  children:[
    //    {
    //      path:'',
    //      component:PartnerConsListComponent
    //    }
    //  ]
  },
  {
    path:'consltantlist',
    component:PartnerConsltantsDashboardComponent
  },
  {
    path:'takeaction',
    component:PartnerConsListComponent
  },
  {
    path:'viewcompleteddocs',
    component:PartnerConsCompleteddocsComponent
  },
  {
    path:'viewinformationdocs',
    component:ViewVendorConInformationDocsComponent
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
